import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { AuthManagerService } from '../services/auth-manager/auth-manager.service';
import { UserService } from '../services/user/user.service';

@Injectable()
export class UnauthInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private authManagerService: AuthManagerService,
    private userService: UserService,
  ) {

  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const skipInterceptor = request.headers.getAll('Skip-Interceptors')?.includes('unauth');
    if (skipInterceptor) {
      return next.handle(request);
    }
    return next.handle(request)
      .pipe(
        catchError((err: any) => {
          if (err instanceof HttpErrorResponse && request.url.indexOf(`${environment.apiUrl}/api/`) === 0) {
            if (err.status === 401) {
              this.authManagerService.removeToken();
              // Skip login redirection on 401 on certain conditions
              if (this.userService.options.disableUnauthRedirect) {
                this.userService.options.disableUnauthRedirect = false;
              } else {
                if (this.userService.options.lastUrlRequested) {
                  // In case the user is on the login page, then we don't need to add the redirect queryParam
                  if (!this.userService.options.lastUrlRequested.includes('/login')) {
                    if (this.userService.options.lastUrlRequested.includes('/claim-pet')){
                      this.router.navigate(['/login'], { queryParams: { r: this.userService.options.lastUrlRequested } });
                      return
                    }
                    if(this.userService.options.lastUrlRequested !== '/login-register') {
                      this.router.navigate(['/login-register'], { queryParams: { r: this.userService.options.lastUrlRequested } });
                    }
                  }
                } else {
                  this.router.navigate(['/login-register']);
                }
              }
            }
          }
          return throwError(err);
        }));
  }
}
